
<style scoped lang="scss">
.qrcode-wrapper {
    background: rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    .blob-image {
        width: 8.72rem;
        height: auto;
        display: block;
    }
    .qrcode-container {
        width: 8.72rem;
        border-radius: 16px;
        background: $white;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 0.733333rem;
        padding-bottom: 0.533333rem;
        .avatar-container {
            border-radius: 50%;
            border: 3px solid #ecf4fd;
            width: 2.133333rem;
            height: 2.133333rem;
            margin-bottom: 0.333333rem;
            .avatar {
                width: 100%;
                height: 100%;
                display: block;
                border-radius: 50%;
            }
        }
        .name {
            font-size: 18px;
            color: #333;
            font-weight: bold;
            margin-bottom: 0.8rem;
            width: 85%;
            text-align: center;
            // @include multiple-text-overflow(2);
        }
        .qrcode {
            margin-bottom: 0.506667rem;
            width: 5.866667rem;
            height: 5.866667rem;
        }
        .info {
            margin-top: 0.56rem;
            color: #999;
            font-size: 15px;
        }
    }
}
</style>

<template>
    <div class="qrcode-wrapper">
        <div class="qrcode-container" ref="container" v-if="!blobUrl">
            <div class="avatar-container">
                <img
                    crossorigin="Anonymous"
                    alt="avatar"
                    class="avatar"
                    :src="ossResolvedAvatar || defaultUser.avatar"
                    @load="loaded = true"
                />
            </div>
            <div
                class="name"
                v-text="userInfo.nick_name || defaultUser.name"
            ></div>
            <qrcode :value="codeStr" :options="{ size: 220 }"></qrcode>
            <div class="info">「长按图片/截图识别二维码，查看更多信息」</div>
        </div>
        <img
            crossorigin="Anonymous"
            class="blob-image"
            :src="blobUrl"
            v-else
            ref="img"
        />
    </div>
</template>

<script>
import VueQrcode from "@xkeshi/vue-qrcode";
import html2canvas from "html2canvas";
export default {
    name: "UserQRCode",
    components: {
        qrcode: VueQrcode,
    },
    props: {
        // layouts: String,
        // layoutType: String,
    },
    data() {
        return {
            defaultUser: {
                avatar:
                    API.ossUrl +
                    "common/empty_icons/noimage-1-1.png?x-oss-process=image/resize,h_300&v=default",
                name: "未知用户",
            },
            userInfo: {},
            userType: 1,
            blobUrl: "",
            codeStr: "",
            loaded: false,
        };
    },
    computed: {
        ossResolvedAvatar() {
            if (!this.userInfo.profile_picture) return "";
            //chrome内核浏览器需要不同的地址（加时间戳） 否则canvas不会加载图片
            return (
                `${
                    this.userInfo.profile_picture
                }?x-oss-process=image/resize,h_300&v=${+new Date().getTime()}` ||
                ""
            );
        },
    },
    watch: {
        codeStr(val) {
            let vm = this;
            if (val) {
                setTimeout(() => {
                    vm.convert2canvas(vm.$refs.container);
                }, 1000);
            }
        },
    },
    created() {
        let { user_info } = sessionStorage;
        if (user_info) {
            this.userInfo = JSON.parse(user_info);
        }
        this.getQrcode();
    },
    mounted() {
        // let vm = this;
        // let timer = setInterval(() => {
        //     if (vm.codeStr && vm.loaded) {
        //         vm.convert2canvas(vm.$refs.container);
        //         clearInterval(timer);
        //     }
        // }, 300);
    },
    destroyed() {},
    methods: {
        convert2canvas(element) {
            let vm = this;
            let shareContent = element;
            let width = shareContent.offsetWidth;
            let height = shareContent.offsetHeight;
            let canvas = document.createElement("canvas");
            let scale = 2;

            canvas.width = width * scale;
            canvas.height = height * scale;
            canvas.getContext("2d").scale(scale, scale);

            let opts = {
                scale: scale,
                canvas: canvas,
                logging: true,
                width: width,
                height: height,
                backgroundColor: null,
                allowTaint: false,
                useCORS: true,
            };
            html2canvas(shareContent, opts).then(function (canvas) {
                let context = canvas.getContext("2d");
                let dataURL = canvas.toDataURL();
                vm.blobUrl = dataURL;
                // var img = Canvas2Image.convertToImage(canvas, canvas.width, canvas.height);
            });
        },
        getQrcode() {
            this.$axios
                .get(
                    `${window.API.user.getQrcode}?token=${sessionStorage.token}`
                )
                .then(({ data }) => {
                    if (data.code == 200) {
                        this.codeStr = data.data[0];
                    } else {
                        this.$toast(data.msg);
                    }
                })
                .catch((err) => console.log(err));
        },
    },
};
</script>
